import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { cloneElement, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Backdrop } from '@mui/material';
import { getPopupSelector } from '@store/popups/popups.selectors';
import { PopupsService } from '@services';
import { popupVariants } from '@components/popup/popup.variants';
import { StyledDialog, StyledPaper } from './popup.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Popup component.
 *
 * @author Mikhail Siutsou
 * @function PopupComponent
 * @category components
 * @param {string} popupId popup id.
 * @return {FC} popup component.
 */
var PopupComponent = function PopupComponent(_ref) {
  var _children$props, _children$props$popUp, _children$props$popUp2;

  var popupId = _ref.popupId;
  var popUp = useSelector(getPopupSelector(popupId));
  var component = popupVariants[popupId];
  /**
   * Reject popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var rejectPopup = useCallback(function () {
    PopupsService.closeWithAnswer(popupId, {
      rejected: true
    });
  }, [popupId]);
  /**
   * Accept popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var acceptPopup = useCallback(function () {
    PopupsService.closeWithAnswer(popupId, {
      accepted: true
    });
  }, [popupId]);
  /**
   * Close popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var handleClose = useCallback(function () {
    rejectPopup();
  }, [rejectPopup]);
  var initialChildProps = useMemo(function () {
    return {
      handleClose: handleClose,
      acceptPopup: acceptPopup,
      rejectPopup: rejectPopup,
      popupId: popupId,
      popUp: popUp
    };
  }, [acceptPopup, handleClose, popupId, rejectPopup, popUp]);
  var popupChild = component ? component(initialChildProps) : null;
  var children = useMemo(function () {
    return popupChild && /*#__PURE__*/cloneElement(popupChild, initialChildProps);
  }, [initialChildProps, popupChild]);
  var popupProps = children !== null && children !== void 0 && children.props ? {
    maxWidth: children.props.maxWidth,
    fullWidth: children.props.fullWidth
  } : {};
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledDialog, _objectSpread(_objectSpread({
      "aria-labelledby": popupId,
      open: popUp && popUp.isOpen ? popUp.isOpen : false,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      },
      PaperComponent: StyledPaper,
      PaperProps: {
        elevation: 0,
        width: children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : (_children$props$popUp = _children$props.popUp) === null || _children$props$popUp === void 0 ? void 0 : (_children$props$popUp2 = _children$props$popUp.data) === null || _children$props$popUp2 === void 0 ? void 0 : _children$props$popUp2.width
      }
    }, popupProps), {}, {
      children: children
    }))
  });
};

export { PopupComponent };